// src/lib/settingsSlugs.js
// URL slug ↔ settings menu/accordion for SettingsView + FinanceSettings (XOL-317).
// Top-level: slug === el-menu index. Keep in sync with the router regex in
// src/router/index.js and SETTINGS_TABS list below.
// Finance sub-sections: URL slug ↔ el-collapse item name. Only `agreements`
// diverges (el-collapse name is `table`, URL slug is `agreements`).

export const SETTINGS_TABS = [
  'orgs-xolas', 'orgs-telco', 'orgs-contractor', 'orgs-backhaul', 'orgs-landlord',
  'orgs-insurer', 'orgs-utility', 'orgs-authority', 'orgs-tower-supplier',
  'workflow', 'cats', 'loc', 'struct', 'finance', 'backup', 'logs'
]

// Finance sub-sections: URL slug ↔ el-collapse item name. Only `agreements` diverges.
export const FINANCE_SLUG_TO_INTERNAL = {
  settings: 'settings',
  agreements: 'table',
  audit: 'audit',
  rates: 'rates',
  builder: 'builder',
  bulk: 'bulk'
}

export const FINANCE_INTERNAL_TO_SLUG = Object.keys(FINANCE_SLUG_TO_INTERNAL)
  .reduce(function (acc, slug) { acc[FINANCE_SLUG_TO_INTERNAL[slug]] = slug; return acc }, {})
